<template>
  <!--<div>-->
  <el-popover placement="bottom-end"
              width="800"
              trigger="click"
              v-model="visible">
    <el-button type="primary"
               slot="reference"
               size="small"
               plain>
      高级搜索
    </el-button>
    <el-form :inline="true"
             :model="listQuery"
             size="small"
             label-width="140px">
      <el-form-item label="店铺名称：">
        <el-input v-model="listQuery.shopName"
                  class="input-width"
                  placeholder="店铺名称"></el-input>
      </el-form-item>
      <el-form-item label="订单号码：">
        <el-input v-model="listQuery.orderNum"
                  class="input-width"
                  placeholder="订单号码"></el-input>
      </el-form-item>
      <el-form-item label="电子邮件：">
        <el-input v-model="listQuery.email"
                  class="input-width"
                  placeholder="电子邮件"></el-input>
      </el-form-item>
      <el-form-item label="购货人：">
        <el-input v-model="listQuery.purchaseGoods"
                  class="input-width"
                  placeholder="购货人"></el-input>
      </el-form-item>
      <el-form-item label="收货人：">
        <el-input v-model="listQuery.receivingGoods"
                  class="input-width"
                  placeholder="收货人"></el-input>
      </el-form-item>
      <el-form-item label="收货地址：">
        <el-input v-model="listQuery.receivingAdd"
                  class="input-width"
                  placeholder="收货地址"></el-input>
      </el-form-item>
      <el-form-item label="邮政编码：">
        <el-input v-model="listQuery.zipCode"
                  class="input-width"
                  placeholder="邮政编码"></el-input>
      </el-form-item>
      <el-form-item label="电话号码：">
        <el-input v-model="listQuery.telephone"
                  class="input-width"
                  placeholder="电话号码"></el-input>
      </el-form-item>
      <el-form-item label="手机号码：">
        <el-input v-model="listQuery.phone"
                  class="input-width"
                  placeholder="手机号码"></el-input>
      </el-form-item>
      <el-form-item label="配送方式：">
        <el-select v-model="listQuery.logistics"
                   class="input-width"
                   placeholder="全部"
                   clearable>
          <el-option v-for="item in logisticsOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态：">
        <el-select v-model="listQuery.orderType"
                   class="input-width"
                   placeholder="全部"
                   clearable>
          <el-option v-for="item in orderTypeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货状态：">
        <el-select v-model="listQuery.deliverType"
                   class="input-width"
                   placeholder="全部"
                   clearable>
          <el-option v-for="item in deliverTypeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在地区：">
        <el-select v-model="listQuery.proType"
                   class="input-width"
                   placeholder="全部"
                   clearable>
          <el-option v-for="item in proTypeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="listQuery.cityType"
                   class="input-width"
                   placeholder="全部"
                   clearable>
          <el-option v-for="item in cityTypeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="listQuery.areaType"
                   class="input-width"
                   placeholder="全部"
                   clearable>
          <el-option v-for="item in areaTypeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间：">
        <el-date-picker class="input-width"
                        v-model="listQuery.placeCreateTime"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择开始时间">
        </el-date-picker>
        <el-date-picker class="input-width"
                        v-model="listQuery.placeEndTime"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="确认收货时间：">
        <el-date-picker class="input-width"
                        v-model="listQuery.conCreateTime"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择开始时间">
        </el-date-picker>
        <el-date-picker class="input-width"
                        v-model="listQuery.conEndTime"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择结束时间">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div style="text-align: center; margin: 0">
      <el-button class="popBtn"
                 size="mini"
                 type="text">重置</el-button>
      <el-button class="popBtn"
                 size="mini"
                 type="text"
                 @click="visible = false">取消</el-button>
      <el-button type="primary"
                 size="mini"
                 @click="visible = false">确定</el-button>
    </div>
  </el-popover>
</template>

<script>
const defaultListQuery = {
  shopName: null,
  orderNum: null,
  purchaseGoods: null,
  receivingGoods: null,
  receivingAdd: null,
  phone: null,
  zipCode: null,
  telephone: null,
  logistics: null,
  orderType: null,
  deliverType: null,
  proType: null,
  cityType: null,
  areaType: null,
  placeCreateTime: null,
  placeEndTime: null,
  conCreateTime: null,
  conEndTime: null
};
export default {
  name: 'choiceItem',
  data() {
    return {
      visible: false,
      listQuery: Object.assign({}, defaultListQuery),
      activeNames: [],
      logisticsOptions: [
        {
          label: '顺丰快递', value: 0
        },
        {
          label: '申通快递', value: 1
        }
      ],
      orderTypeOptions: [
        {
          label: '未确认', value: 0
        },
        {
          label: '已确认', value: 1
        },
        {
          label: '取消', value: 2
        },
        {
          label: '无效', value: 3
        },
        {
          label: '退货', value: 4
        },
        {
          label: '已分单', value: 5
        },
        {
          label: '部分已退货', value: 6
        },
        {
          label: '仅退款', value: 7
        },
      ],
      deliverTypeOptions: [
        {
          label: '未发货', value: 0
        },
        {
          label: '配货中', value: 1
        },
        {
          label: '已发货', value: 2
        },
        {
          label: '收货确认', value: 3
        },
        {
          label: '发货中', value: 4
        }
      ],
      proTypeOptions: [
        {
          label: '福建省', value: 0
        },
        {
          label: '河北省', value: 1
        },
        {
          label: '陕西省', value: 2
        }
      ],
      cityTypeOptions: [
        {
          label: '福州市', value: 0
        },
        {
          label: '南平市', value: 1
        },
        {
          label: '厦门市', value: 2
        }
      ],
      areaTypeOptions: [
        {
          label: '思明区', value: 0
        },
        {
          label: '湖里区', value: 1
        },
        {
          label: '集美区', value: 2
        },
      ]
    }
  },
  methods: {

  }
}
</script>

<style>
.input-width {
  width: 203px;
}
.popBtn {
  margin-right: 5vw;
}
</style>


// WEBPACK FOOTER //
// src/views/oms/order/components/choiceItem.vue